import { create } from 'zustand';
import {
  RECALIBRATION_FLAG_DEFAULTS,
  type RecalibrationFlagKey,
} from '../constants/feature-flags';
import {
  onFeatureFlagsChange,
  type FeatureFlagMap,
} from '../services/feature-flags';

interface FeatureFlagState {
  flags: FeatureFlagMap;
  /** True once the live override doc has been read at least once. */
  loaded: boolean;
  isEnabled: (key: RecalibrationFlagKey) => boolean;
  /** Subscribe to the global flag doc. Returns an unsubscribe fn. */
  listen: () => () => void;
}

export const useFeatureFlagStore = create<FeatureFlagState>((set, get) => ({
  // Start from defaults so gating is correct before the doc loads (no flicker
  // of GA features, and Coach stays off until the doc explicitly enables it).
  flags: { ...RECALIBRATION_FLAG_DEFAULTS },
  loaded: false,

  isEnabled: (key) => get().flags[key],

  listen: () =>
    onFeatureFlagsChange((flags) => set({ flags, loaded: true })),
}));
